import deleteItemsStoreUpdate, {
    ItemContext,
} from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { orchestrator } from 'satcheljs';
import { lazyCleanUpItemClientSide } from 'owa-mail-reading-pane-store';

export default orchestrator(deleteItemsStoreUpdate, actionMessage => {
    const itemContexts: ItemContext[] = actionMessage.itemContexts;
    for (const itemContext of itemContexts) {
        lazyCleanUpItemClientSide.importAndExecute(
            { Id: itemContext.itemId },
            itemContext.itemConversationId
        );
    }
});
